import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const ShortLinkRedirect = () => {
  const { code } = useParams<{ code: string }>();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!code) {
      setError("Invalid link");
      return;
    }

    const resolve = async () => {
      try {
        const res = await fetch(
          `https://uhtgcidyxprykowgsahq.supabase.co/functions/v1/resolve-short-link?code=${encodeURIComponent(code)}`
        );

        if (!res.ok) {
          const err = await res.json();
          setError(err.error || "Link not found");
          return;
        }

        const result = await res.json();
        window.location.replace(result.target_url);
      } catch {
        setError("Something went wrong");
      }
    };

    resolve();
  }, [code]);

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground gap-4">
        <h1 className="text-2xl font-bold">Link Not Found</h1>
        <p className="text-muted-foreground">{error}</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-muted-foreground animate-pulse">Redirecting…</div>
    </div>
  );
};

export default ShortLinkRedirect;
